// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 285) return "static/css/285.a386843cc37753da0e14.lib.css";
	if (chunkId === 639) return "static/css/639.68c2572221c8393da78c.css";
	// return url for filenames based on template
	return undefined;
};